export const DwellIconSm = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 152.13 152.66"
      enableBackground="new 0 0 152.13 152.66"
      xmlSpace="preserve"
      width="50px"
      height="50px"
    >
      <path
        d="M145.96 152.66H20.71c-3.41 0-6.17-2.76-6.17-6.17V21.24c0-3.41 2.76-6.17 6.17-6.17h125.25c3.41 0 6.17 2.76 6.17 6.17v125.25c0 3.4-2.76 6.17-6.17 6.17z"
        opacity="0.2"
        fill="#641abf"
        enableBackground="new"
      />
      <path
        d="M133.34 139.51H8.09c-3.41 0-6.17-2.76-6.17-6.17V8.09c0-3.41 2.76-6.17 6.17-6.17h125.25c3.41 0 6.17 2.76 6.17 6.17v125.25c0 3.41-2.76 6.17-6.17 6.17z"
        fill="#fff"
        stroke="#641abf"
        strokeWidth="3.8396"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M64.84 100.81c-3.9 0-7.3-.9-10.2-2.8s-5.2-4.6-6.9-8c-1.6-3.5-2.5-7.6-2.5-12.3 0-4.8.8-8.9 2.5-12.3 1.6-3.4 3.9-6.1 6.9-7.9 2.9-2 6.3-2.9 10.2-2.9 3.7 0 6.9.9 9.7 2.7 2.8 1.8 4.6 4.2 5.6 7.2h-1v-23.6c0-1.9.5-3.3 1.5-4.3s2.4-1.5 4.2-1.5c1.8 0 3.2.5 4.2 1.5s1.5 2.4 1.5 4.3v53.9c0 1.9-.5 3.3-1.5 4.3s-2.4 1.5-4.2 1.5c-1.8 0-3.2-.5-4.2-1.5s-1.5-2.4-1.5-4.3v-7.1l1 2.7c-.9 3.1-2.8 5.7-5.5 7.5-2.8 2-6.1 2.9-9.8 2.9zm3.1-8.6c2.2 0 4.2-.5 5.9-1.6 1.7-1.1 3-2.7 3.9-4.9.9-2.1 1.4-4.8 1.4-8 0-4.8-1-8.5-3.1-10.8-2.1-2.4-4.8-3.6-8.2-3.6-2.2 0-4.2.5-5.9 1.6-1.7 1.1-3 2.7-3.9 4.8-.9 2.1-1.4 4.8-1.4 8 0 4.8 1 8.4 3.1 10.8s4.8 3.7 8.2 3.7z"
        fill="#641abf"
      />
    </svg>
  );
};

export default DwellIconSm;
